export class ValidationErrorBase {
    
	errorCode!:string;
    errorMsg!:string;


    static from(entity: ValidationError): ValidationErrorBase {

        let current = new ValidationErrorBase();
        Object.assign(current, entity)       
        return current;
    }
}

export interface ValidationError extends ValidationErrorBase {

}